import React, { useEffect } from 'react';
import ConfettiGenerator from 'confetti-js';

import ReactPortal from 'Dashboard/ReactPortal/ReactPortal';

import './Confetti.scss';

type Props = {
  className?: string;
  darkBackdrop?: boolean;
  confettiSettings?: object;
  appendToPage?: boolean;
};

const defaultSettings = { max: 200, rotate: true };

export default function Confetti({
  className,
  darkBackdrop,
  confettiSettings = defaultSettings,
  appendToPage = true,
}: Props) {
  useEffect(() => {
    const settings = { target: 'confetti-canvas', ...confettiSettings };
    const confetti = new ConfettiGenerator(settings);
    confetti.render();

    return () => confetti.clear();
  }, []);

  const content = (
    <div className={`${className}`}>
      <canvas className="confetti" id="confetti-canvas" />
      {darkBackdrop ? <div className="confetti-backdrop-dark" /> : null}
    </div>
  );

  return <>{appendToPage ? <ReactPortal>{content}</ReactPortal> : <>{content}</>}</>;
}
